import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function LinkOutline(props: SvgIconProps) {
  const { color, ...rest } = props;
  return (
    <SvgIcon
      {...rest}
      viewBox='0 0 24 24'
    >
      <g clipPath='url(#clip0_209_157)'>
        <path
          d='M8 12C8 12.2652 8.10536 12.5196 8.29289 12.7071C8.48043 12.8946 8.73478 13 9 13H15C15.2652 13 15.5196 12.8946 15.7071 12.7071C15.8946 12.5196 16 12.2652 16 12C16 11.7348 15.8946 11.4804 15.7071 11.2929C15.5196 11.1054 15.2652 11 15 11H9C8.73478 11 8.48043 11.1054 8.29289 11.2929C8.10536 11.4804 8 11.7348 8 12Z'
          fill={color}
        />
        <path
          d='M8.99979 16H7.20979C6.18215 16.0274 5.18122 15.6706 4.40266 14.9993C3.6241 14.328 3.12389 13.3905 2.99979 12.37C2.94818 11.8145 3.01336 11.2543 3.19113 10.7254C3.36891 10.1966 3.65536 9.71076 4.03206 9.29921C4.40877 8.88765 4.86741 8.55946 5.37851 8.33571C5.88961 8.11196 6.44187 7.99761 6.99979 8H8.99979C9.26501 8 9.51937 7.89464 9.7069 7.70711C9.89444 7.51957 9.99979 7.26522 9.99979 7C9.99979 6.73478 9.89444 6.48043 9.7069 6.29289C9.51937 6.10536 9.26501 6 8.99979 6H7.20979C5.72752 5.98019 4.28796 6.49645 3.1561 7.45376C2.02424 8.41106 1.27624 9.74499 1.04979 11.21C0.937241 12.0574 1.00706 12.9191 1.25458 13.7373C1.5021 14.5555 1.9216 15.3114 2.48498 15.9543C3.04837 16.5972 3.74263 17.1124 4.52127 17.4652C5.29991 17.818 6.14495 18.0003 6.99979 18H8.99979C9.26501 18 9.51937 17.8946 9.7069 17.7071C9.89444 17.5196 9.99979 17.2652 9.99979 17C9.99979 16.7348 9.89444 16.4804 9.7069 16.2929C9.51937 16.1054 9.26501 16 8.99979 16Z'
          fill={color}
        />
        <path
          d='M23 11.24C22.7764 9.75655 22.0191 8.40567 20.8702 7.44089C19.7213 6.47612 18.2598 5.96379 16.76 6.00003H15.25C14.44 6.00003 14 6.45003 14 7.00003C14 7.26525 14.1054 7.5196 14.2929 7.70714C14.4804 7.89467 14.7348 8.00003 15 8.00003H16.79C17.8176 7.9726 18.8186 8.32941 19.5971 9.00071C20.3757 9.67201 20.8759 10.6095 21 11.63C21.0516 12.1856 20.9864 12.7458 20.8087 13.2746C20.6309 13.8035 20.3444 14.2893 19.9677 14.7008C19.591 15.1124 19.1324 15.4406 18.6213 15.6643C18.1102 15.8881 17.5579 16.0024 17 16H15C14.7348 16 14.4804 16.1054 14.2929 16.2929C14.1054 16.4805 14 16.7348 14 17C14 17.2652 14.1054 17.5196 14.2929 17.7071C14.4804 17.8947 14.7348 18 15 18H17C17.8562 18.0069 18.7039 17.8305 19.4862 17.4826C20.2686 17.1347 20.9674 16.6235 21.5357 15.9831C22.1041 15.3428 22.5288 14.5882 22.7814 13.7701C23.0339 12.952 23.1085 12.0893 23 11.24Z'
          fill={color}
        />
      </g>
      <defs>
        <clipPath id='clip0_209_157'>
          <rect
            width='24'
            height='24'
            fill='transparent'
          />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}
